module.exports = __webpack_public_path__ + "media/images/image6-c401654991686c82e69aac15c594d2e7.png";